module.exports = __webpack_public_path__ + "571956abcff8e9ed0fe2e94955ef345f.json";


//////////////////
// WEBPACK FOOTER
// ./src/portal/i18n/ja.json
// module id = 1127
// module chunks = 0